(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["essential"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  function fireAsyncLazyLoad() {
    try {
      document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
    } catch (e) {
      // noop
    }
  }

  function oneShotRepair() {
    try {
      document.querySelectorAll('script[data-src]').forEach(function (s) {
        var val = s.getAttribute('data-src');
        if (val && !s.src) s.src = val;
        s.removeAttribute('data-src');
      });

      // <link data-href> → href へ
      document.querySelectorAll('link[data-href]').forEach(function (lnk) {
        var val = lnk.getAttribute('data-href');
        if (val) lnk.setAttribute('href', val);
        lnk.removeAttribute('data-href');
      });      

      // <iframe data-src> → src へ
      document.querySelectorAll('iframe[data-src]').forEach(function (ifr) {
        var val = ifr.getAttribute('data-src');
        if (val && !ifr.src) ifr.src = val;
        ifr.removeAttribute('data-src');
      });
      fireAsyncLazyLoad();
    } catch (e) {
      // noop
    }
  }

  // observe wxcept SCRIPT.
  function startObserver() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;

          if (node.tagName === 'SCRIPT') return;

          if (node.tagName === 'LINK' && node.hasAttribute('data-href')) {
            var href = node.getAttribute('data-href');
            if (href) node.setAttribute('href', href);
            node.removeAttribute('data-href');
          }

          if (node.tagName === 'IFRAME' && node.dataset && node.dataset.src) {
            if (!node.src) node.src = node.dataset.src;
            delete node.dataset.src;
          }
          // 画像の遅延は lazysizes に任せるため、ここでは何もしない
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      oneShotRepair();
      startObserver();
    });
  } else {
    oneShotRepair();
    startObserver();
  }

  var firedOnActivity = false;
  var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];
  function onFirstActivity() {
    if (firedOnActivity) return;
    firedOnActivity = true;
    fireAsyncLazyLoad();
    activityEvents.forEach(function (ev) {
      window.removeEventListener(ev, onFirstActivity, false);
    });
  }
  activityEvents.forEach(function (ev) {
    window.addEventListener(ev, onFirstActivity, false);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
